import { LIST_NOTIFICATIONS, LIST_SCHOOLS, SCHOOL } from "../util/constants";
import { sendRequest } from "./base";

export const getAllNotifications = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {

    //alert(JSON.stringify(LIST_NOTIFICATIONS));
    return sendRequest(data, "GET", LIST_NOTIFICATIONS, { Authorization });
  } catch (err) {
    return err;
  }
};

export const addSchool = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", SCHOOL, { Authorization });
  } catch (err) {
    return err;
  }
};

export const editSchool = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "PUT", `${SCHOOL}?id=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};

export const deleteSchool = async (id, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest({}, "DELETE", `${SCHOOL}?id=${id}`, { Authorization });
  } catch (err) {
    return err;
  }
};
export const searchSchools = async (data, SearchValue, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(
      data,
      "POST",
      `${LIST_SCHOOLS}?searchBy=${SearchValue}`,
      {
        Authorization,
      }
    );
  } catch (e) {
    return e;
  }
};
